module.exports = __webpack_public_path__ + "img/close-square.99188505.svg";